import metadataProfileMutations from "./mutations.js";
import metadataProfileActions from "./actions.js";
import metadataProfileGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: metadataProfileMutations,
  actions: metadataProfileActions,
  getters: metadataProfileGetters,
};
